<a [routerLink]="routerLink()" routerLinkActive="active">
    @if (icon(); as icon) {
        <cl-icon [icon]="icon" />
    }
    <span>{{ label() }}</span>
</a>
